const map = {
	"./BuddhaAkshay/images/LoginLogo.svg": [
		2407,
		[
			407
		]
	],
	"./JanBhavishya/images/LoginLogo.svg": [
		97530,
		[
			530
		]
	],
	"./Suvarna/images/LoginLogo.svg": [
		88532,
		[
			532
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86259;
module.exports = webpackAsyncContext;